var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagGerman = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
  fill: "#C4C4C4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V8H0V0Z",
  fill: "#151515"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8H24V16H0V8Z",
  fill: "#DB2727"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 16H24V24H0V16Z",
  fill: "#F8D12E"
}))));
export default SvgFlagGerman;